import { render, staticRenderFns } from "./PatientRoute.vue?vue&type=template&id=93fd9b68"
import script from "./PatientRoute.vue?vue&type=script&lang=js"
export * from "./PatientRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports